import type { FC } from 'react';
import { Navigate, Route } from 'react-router';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { H2FcfsBooking } from 'src/pages/h2/fcfs/booking';
import { HydrogenInteractingUsers } from 'src/pages/h2/fcfs/interacting-users';
import { HydrogenOperatorBookings } from 'src/pages/h2/fcfs/operator-bookings';
import { HydrogenShipperBookings } from 'src/pages/h2/fcfs/shipper-bookings';
import { NetworkPoints } from 'src/pages/h2/network-points';

export const H2: FC = () => {
  return (
    <RootRoutes>
      <Route path="/h2" element={<Navigate to="/h2/network-points" />} />
      <Route path="/h2/fcfs" element={<Navigate to="/h2/fcfs/booking" />} />
      <Route path="/h2/fcfs/booking/*" element={<H2FcfsBooking />} />
      <Route
        path="/h2/fcfs/shipper-bookings/*"
        element={<HydrogenShipperBookings />}
      />
      <Route
        path="/h2/fcfs/interacting-users/*"
        element={<HydrogenInteractingUsers />}
      />
      <Route
        path="/h2/fcfs/operator-bookings/*"
        element={<HydrogenOperatorBookings />}
      />
      <Route path="/h2/network-points/*" element={<NetworkPoints />} />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
